(function ($) {
  $(document).ready(function () {
    // Track clicks on email links
    $(document).on('click', 'a[href^="mailto:"]', function () {
      var email = $(this).attr('href').replace('mailto:', '');
      dataLayer.push({
        event: 'email_click',
        email: email,
      });
    });

    // Track clicks on phone links
    $(document).on('click', 'a[href^="tel:"]', function () {
      var phone = $(this).attr('href').replace('tel:', '');
      dataLayer.push({
        event: 'phone_click',
        phone: phone,
      });
    });

    // Track form submissions
    $('.js-newsletter-form form').on('submit', function () {
      dataLayer.push({
        event: 'newsletter_subscribe',
        email: $(this).find('input[type="email"]').val(),
      });
    });

    // Track button clicks
    $('.js-demo-results-btn a').on('click', function () {
      dataLayer.push({
        event: 'button_demo_vysledky',
      });
    });

    if (typeof window.gtm4wp_add_to_cart !== 'undefined') {
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: window.gtm4wp_add_to_cart.currencyCode,
          add: {
            products: gtm4wp_add_to_cart.products,
          },
        },
      });
    }
  });
})(jQuery);
